(ns app.front.view.workspace.alerts
  (:require [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.view.project.subs :as ps]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::user-sees-approval-alert?
  :<- [:session/user]
  (fn [{:user/keys [authority? stakeholder?]} _]
    (or authority? stakeholder?)))

(rf/reg-sub ::phase-entity-ids
  (fn [_]
    [(rf/subscribe [::entities/entity-db])
     (rf/subscribe [::ws-subs/workspace-entity-id])])
  (ps/child-entity-sub-fn workspace-model/phase-entity-types))

(rf/reg-sub ::approval-ids
  (ps/child-entity-sub-signal-fn ::phase-entity-ids)
  (ps/child-entity-sub-fn :entity.type/approval))

(rf/reg-sub ::approvals
  :<- [::approval-ids]
  (fn [approval-ids _]
    (<sub [::entities/entities approval-ids])))

(rf/reg-sub ::approval-first-due
  :<- [::approvals]
  (fn [approvals _]
    (some->> approvals
             (filter (du/in-state-fn :approval.state/requested
                                     :approval.state/draft))
             (mapcat :task/_reference)
             (keep :task/due)
             seq
             (apply min))))

(defn approval-delta->alert [tr day-delta]
  (cond
    (< 21 day-delta)  nil
    (< 14 day-delta)  [:low (tr [:circulation/due-date-alert] [day-delta])]
    (< 7 day-delta)   [:medium (tr [:circulation/due-date-alert] [day-delta])]
    (< 1 day-delta)   [:high (tr [:circulation/due-date-alert] [day-delta])]
    (= 1 day-delta)   [:high (tr [:circulation/due-date-alert-one-day])]
    (zero? day-delta) [:high (tr [:circulation/due-today])]
    (= -1 day-delta)  [:high (tr [:circulation/overdue-by-one-day])]
    :else             [:high (tr [:circulation/overdue-by] [(abs day-delta)])]))

(rf/reg-sub ::approval-due-alert
  :<- [::user-sees-approval-alert?]
  ;; TODO are we in-review or whatever phases are applicable?
  :<- [::approval-first-due]
  :<- [::ws-subs/tr]
  (fn [[show-alert? due-date tr] _]
    (when (and show-alert? due-date)
      (let [day-delta (date-util/number-of-days-between-two-dates (date-util/today-end-of-day)
                                                                  due-date)]
        (approval-delta->alert tr day-delta)))))

(rf/reg-sub ::review-ids
  (ps/child-entity-sub-signal-fn ::phase-entity-ids)
  (ps/child-entity-sub-fn :entity.type/review))

(rf/reg-sub ::reviews
  :<- [::review-ids]
  (fn [review-ids _]
    (<sub [::entities/entities review-ids])))

(rf/reg-sub ::review-first-due-for-current-user
  :<- [::reviews]
  :<- [:session/user-id]
  (fn [[reviews reviewer-user-id] _]
    (some->> reviews
             (filter #(contains? #{:review.status/unreviewed
                                   :review.status/in-review
                                   :review.status/changes-requested}
                                 (:review/status %)))
             (filter #(= reviewer-user-id (-> % :review/assignee :db/id)))
             (keep :review/due-date)
             seq
             (apply min))))

(defn review-delta->alert [tr day-delta]
  (cond
    (< 21 day-delta)  nil
    (< 14 day-delta)  [:low (tr [:review/due-date-alert] [day-delta])]
    (< 7 day-delta)   [:medium (tr [:review/due-date-alert] [day-delta])]
    (< 1 day-delta)   [:high (tr [:review/due-date-alert] [day-delta])]
    (= 1 day-delta)   [:high (tr [:review/due-date-alert-one-day])]
    (zero? day-delta) [:high (tr [:review/due-date-alert-today])]
    (neg? day-delta)  [:high (tr [:review/due-date-alert-overdue] [(abs day-delta)])]))

(rf/reg-sub ::review-due-alert
  :<- [::user-sees-approval-alert?]
  :<- [::review-first-due-for-current-user]
  :<- [::ws-subs/tr]
  (fn [[show-alert? due-date tr] _]
    (when (and show-alert? due-date)
      (let [day-delta (date-util/number-of-days-between-two-dates (date-util/today-end-of-day)
                                                                  due-date)]
        (review-delta->alert tr day-delta)))))

(rf/reg-sub ::visible-alerts
  :<- [::approval-due-alert]
  :<- [::review-due-alert]
  (fn [[approval-alert review-alert] _]
    (->> [approval-alert review-alert]
         (remove nil?))))
